import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Variant } from '@mui/material/styles/createTypography';
import React from 'react';
import { theme } from '../../../shared/theme';
export const FilterLabel = styled(Button)`
    display: block;
`;

interface StyledFilterButtonProps {
    hasError?: boolean;
    device?: any;
    disabled?: boolean;
}

export type ExtendedVariant = Variant | 'body3';

export const StyledFilterButton = styled(Button, {
    shouldForwardProp: (propName) => propName !== 'hasError',
})<StyledFilterButtonProps>(({ device, hasError, disabled, onClick }) => ({
    height: '42px',
    width: '100%',
    display: 'flex',
    alignItems: device === 'true' ? 'flex-start' : 'center',
    marginBottom: device === 'true' ? '10px' : '0px',
    marginRight: device === 'true' ? '0px' : '10px',
    flexGrow: 1,
    minWidth: 0,

    fontSize: '14px',
    justifyContent: 'flex-start',
    backgroundColor: disabled
        ? theme.palette.faded.main
        : theme.palette.neutral.main,

    borderColor: disabled
        ? theme.palette.faded.main
        : theme.palette.neutral.main,
    '&:hover': {
        backgroundColor: theme.palette.neutral.main,
        borderColor: theme.palette.midGrey.main,
    },
}));
export function StyledFilterText({
    children,
    variant = 'body3',
}: {
    children: any;
    variant: ExtendedVariant;
}) {
    const typo = theme.typography[variant] ?? theme.typography.body2;

    return (
        <Box
            component='div'
            sx={{
                ...typo,
                color: 'inherit',
                textTransform: 'capitalize',
                display: 'inline-flex',
                flexDirection: 'row',
                alignItems: 'center',
                flexWrap: 'nowrap',
                gap: 0.25,
                flex: '0 0 auto',
                minWidth: 'min-content',
                overflow: 'visible',
                whiteSpace: 'nowrap',
                '& .MuiGrid-root': {
                    flexWrap: 'nowrap',
                    minWidth: 'min-content',
                },
            }}
        >
            {children}
        </Box>
    );
}
